import { PENDING_MEDICATION_CHANGE } from '../actions/pendingMedicationActions';

const initialState = {
  pendingApplications: 0,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case PENDING_MEDICATION_CHANGE:
      return {
        ...state,
        pendingApplications: action.payload.actualPendingApplications,
      };
    default:
      return state;
  }
}
